import React, { useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useScrollAnimation } from '../hooks/useScrollAnimation'
import Hero from './Hero'
import LogoSection from './LogoSection'
import Projects from './Projects'
import Problems from './Problems'
import FAQ from './FAQ'
import Blog from './Blog'

const AnimatedSection = ({ children, className = "" }: { children: React.ReactNode, className?: string }) => {
    const { ref, isVisible } = useScrollAnimation()

    return (
        <div ref={ref} className={`reveal ${isVisible ? 'active' : ''} ${className}`}>
            {children}
        </div>
    )
}

const Home: React.FC = () => {
    // Structured Data for Local Business
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "RealEstateAgent",
        "name": "Singh's Best Buy",
        "image": "https://www.singhsbestbuy.com/logo.png",
        "@id": "https://www.singhsbestbuy.com",
        "url": "https://www.singhsbestbuy.com",
        "telephone": "+918368225412",
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Golf Course Extension Road",
            "addressLocality": "Gurgaon",
            "postalCode": "122001",
            "addressCountry": "IN"
        },
        "geo": {
            "@type": "GeoCoordinates",
            "latitude": 28.4595,
            "longitude": 77.0266
        },
        "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday"
            ],
            "opens": "10:00",
            "closes": "19:00"
        },
        "sameAs": [
            "https://www.facebook.com/singhsbestbuy",
            "https://www.instagram.com/singhsbestbuy"
        ]
    };

    return (
        <div id="home" className="overflow-hidden">
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>

            <Hero />

            <AnimatedSection className="bg-white relative z-10">
                <LogoSection />
            </AnimatedSection>

            <AnimatedSection className="bg-gray-50/50">
                <Projects />
            </AnimatedSection>

            <AnimatedSection className="bg-gradient-to-b from-white to-gray-50">
                <Problems />
            </AnimatedSection>



            <AnimatedSection className="bg-secondary/5">
                <FAQ />
            </AnimatedSection>

            <AnimatedSection>
                <Blog />
            </AnimatedSection>
        </div>
    )
}

export default Home
